 <banner-notification *ngIf="offerEndDate | countDown | async" [showIcon]="true"
   [alertLevel]="notificationAlertLevel.Lead">
   <span
     message>{{offerEndDate | countDown | async | humanizeDate:humanizeConfig | bannerNotificationOfferMessage:contactsSummary:province}}</span>
   <mat-icon (click)="onDeclineClick()" style="color: red; cursor: pointer; transform: scale(1.25); min-width: 24px;">cancel</mat-icon>
   <mat-icon (click)="onAcceptClick()"
     style="color: green; margin-left: 0.5rem; cursor: pointer; transform: scale(1.25); min-width: 24px;">
     check_circle
   </mat-icon>
 </banner-notification>
